import { all, call, put, takeEvery } from 'redux-saga/effects'
import { getTutorials, setGuideCompleted } from 'shared/api/tutorials.api'
import {
  GUIDES_COMPLETED_REQUESTED,
  GUIDES_FETCH_FAILED,
  GUIDES_FETCH_REQUESTED,
  GUIDES_FETCH_SUCCESS,
  GUIDE_COMPLETED_REQUESTED,
  GUIDE_COMPLETED_SUCCESS,
} from './actionTypes'
import { GuidesActionTypes } from './types'

function* fetchGuides(): any {
  try {
    const response = yield call(getTutorials)
    yield put({
      type: GUIDES_FETCH_SUCCESS,
      payload: response.data,
    })
  } catch (e) {
    yield put({ type: GUIDES_FETCH_FAILED, payload: e })
  }
}

function* setCompleted(action: GuidesActionTypes): any {
  try {
    yield call(setGuideCompleted, action.payload)
    yield put({
      type: GUIDE_COMPLETED_SUCCESS,
    })
  } catch (e) {
    yield put({ type: GUIDES_FETCH_FAILED, payload: e })
  }
}

function* setMultipleCompleted(action: GuidesActionTypes) {
  try {
    const calls: any[] = []
    action.payload.forEach((x: string) => {
      calls.push(call(setGuideCompleted, x))
    })

    yield all(calls)

    yield put({
      type: GUIDE_COMPLETED_SUCCESS,
    })
  } catch (e) {
    yield put({ type: GUIDES_FETCH_FAILED, payload: e })
  }
}

function* guidesSaga() {
  yield takeEvery(GUIDES_FETCH_REQUESTED, fetchGuides)
  yield takeEvery(GUIDE_COMPLETED_REQUESTED, setCompleted)
  yield takeEvery(GUIDES_COMPLETED_REQUESTED, setMultipleCompleted)
  yield takeEvery(GUIDE_COMPLETED_SUCCESS, fetchGuides)
}

export default guidesSaga
